import { useState } from "react";

import { Box, CircularProgress } from "@mui/material";

import { TCourseDocument } from "../../../../@types";

export type TCourseDocumentVideoProps = {
	file: TCourseDocument;
};

export function CourseDocumentVideo({ file }: TCourseDocumentVideoProps) {
	const [isLoading, setIsLoading] = useState(true);

	const onLoad = () => {
		setIsLoading(false);
	};

	return (
		<div className="media-container">
			<video className="media" onLoadedMetadata={onLoad} playsInline>
				<source src={file.url} type="video/mp4" />
			</video>
			{isLoading && (
				<Box sx={{ position: "absolute", zIndex: 1, display: "inline-flex" }}>
					<CircularProgress />
				</Box>
			)}
		</div>
	);
}
